import { fullScreenToggled } from '../../ui/ui';

const toggleFullScreen = () => (dispatch) => {
  dispatch(fullScreenToggled());
};

export default toggleFullScreen;
